import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class AutocompleteListResult extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    formName: PropTypes.string,
  }

  static defaultProps = {
    formName: '',
  }

  render() {
    return (
      <li className="Tag Tag--truncate Tag--selected">
        { this.props.name }
        <a onClick={this.props.onClick} className="Tag-close">×</a>
        { this.props.formName && <input type="hidden" name={this.props.formName} value={this.props.id} /> }
      </li>
    );
  }
}
